/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const networkInfrastructureEnumsAffectedRedundancyLevelOptionEnum = {
    NPlus1: 'NPlus1',
    V2N: 'V2N',
    SinglePointOfFailure: 'SinglePointOfFailure',
    Other: 'Other',
} as const;

export type NetworkInfrastructureEnumsAffectedRedundancyLevelOptionEnumKey =
    (typeof networkInfrastructureEnumsAffectedRedundancyLevelOptionEnum)[keyof typeof networkInfrastructureEnumsAffectedRedundancyLevelOptionEnum];

export type NetworkInfrastructureEnumsAffectedRedundancyLevelOption =
    NetworkInfrastructureEnumsAffectedRedundancyLevelOptionEnumKey;
